'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _PlusCircleOutlined = _interopRequireDefault(require('./lib/icons/PlusCircleOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _PlusCircleOutlined;
  exports.default = _default;
  module.exports = _default;